import React, { useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText
} from 'reactstrap';

const TopBar = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div>
      <Navbar light expand="md" style={{'background-color':'inherit'}}>
        <NavbarBrand href="#home"><img src="logo.png" height="95" width="95"></img></NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar className="d-flex flex-row justify-content-end" style={{'background-color':'inherit'}}>
          <Nav navbar>
            <NavItem>
              <NavLink style={{'color':'inherit','font-size':'1.1em'}} href="#home">Home</NavLink>
            </NavItem>
            <NavItem>
              <NavLink style={{'color':'inherit','font-size':'1.1em'}} href="#style-transfer">NFT Style Transfer</NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}

export default TopBar;